import React, { useState } from 'react';

import { Page } from '../../../api-client';
import { Container, Section } from '../../../components';
import { createPageProvider } from '../../../di';
import { useEffectOnMount } from '../../../hooks';

const PersonalDataPolicy = () => {
  const [page, setPage] = useState<Page | null>(null);
  const [error, setError] = useState<string | null>(null);
  const loadPage = async () => {
    try {
      const provider = await createPageProvider();
      setPage(await provider.getOne('politics'));
    } catch (e) {
      setError('Ошибка загрузки страницы');
    }
  };

  useEffectOnMount(() => {
    loadPage();
  });

  const renderPage = () => {
    return page ? <div dangerouslySetInnerHTML={{ __html: page?.content }}></div> : <div />;
  };

  return (
    <Section>
      <Container>
        {error && <div>{error}</div>}
        {renderPage()}
      </Container>
    </Section>
  );
};

export default PersonalDataPolicy;
